<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <Row>
      <Col span="24">
        <Card class="margin-bottom-10">
          <Form inline>


            <FormItem class='margin-bottom-0'>
              <Select clearable v-model='searchConf.lotteryType' clearable
                      :placeholder="$t('彩种') " style='width:120px'>

                <Option :key="key" :value="value['lotteryType']"
                        v-for="(value, key) in lotteryParams"> {{ value['lotteryName'] }}
                </Option>
              </Select>
            </FormItem>

            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.yearIssue' :placeholder="$t('年度期号') "></Input>
            </FormItem>

            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t("find_button") }}</Button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row>        <!--    -->

    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
          <div class='margin-bottom-15'>
            <Button type='primary'  @click='preAdd' icon='md-add'>{{
                $t('add_button')
              }}
            </Button>
          </div>
          <!-- DATA -->
          <div>
            <Table @on-sort-change="sortChange" :loading='listLoading' :columns='columnsList' :data='tableData'
                   border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>

    <!-- windowAddEdit -->
    <Modal v-model="windowAdd.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowAddCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowAddItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowAddForm" :rules="windowAddValidate" :model="windowAddItem" :label-width="80"
            label-position="left">
        <FormItem label='彩种' prop='title'>
          <Select clearable v-model='windowAddItem.lotteryType' clearable :disabled="windowAddItem.id>0"
                  :placeholder="$t('彩种') " style='width:120px'>

            <Option :key="key" :value="value['lotteryType']"
                    v-for="(value, key) in lotteryParams"> {{ value['lotteryName'] }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="年份期号">
          <Input :disabled="windowAddItem.id>0" clearable v-model='windowAddItem.yearIssue' :placeholder="$t('请输入年份期号')"></Input>
        </FormItem>
        <FormItem label="期号">
          <Input :disabled="windowAddItem.id>0" clearable v-model='windowAddItem.issue' :placeholder="$t('请输入期号')"></Input>
        </FormItem>
        <FormItem label='九肖' >
          <Input clearable v-model='windowAddItem.jiuxiao' :placeholder="$t('请输入九肖')"></Input>
        </FormItem>
        <FormItem label='十码' prop='shima'>
          <Input clearable v-model='windowAddItem.shima' :placeholder="$t('请输入十码')"></Input>
        </FormItem>
        <FormItem label='中奖生肖'>
          <Input clearable v-model='windowAddItem.openedSx' :placeholder="$t('请输入开奖生肖,未开奖时留空')"></Input>
        </FormItem>
        <FormItem label='特码' >
          <Input clearable v-model='windowAddItem.openedNum' :placeholder="$t('请输入特码,未开奖时输入0')"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowAddCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAddSubmit" :loading="windowAdd.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->

  </div>
</template>
<script>
import {
  customPost
} from '@/api/Lhc/Lhc'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'

export default {
  name: 'interface_list',
  data() {
    return {
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value() {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value() {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value() {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [ {
        title: this.$t('玩法'),
        key: 'lotteryName',
        minWidth: 50,
        align: 'center'
      },{
        title: this.$t('期号'),
        key: 'yearIssue',
        minWidth: 50,
        align: 'center'
      },{
        title: this.$t('九肖'),
        key: 'jiuxiao',
        minWidth: 120,
        align: 'center'
      },{
        title: this.$t('十码'),
        key: 'shima',
        minWidth: 120,
        align: 'center'
      },{
        title: this.$t('开奖生肖'),
        key: 'openedSx',
        minWidth: 120,
        align: 'center'
      },{
        title: this.$t('开奖特码'),
        key: 'openedNum',
        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('操作'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('Button', {
            props: {
              type: 'primary'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                let vm = this
                vm.windowAddItem.id=params.row.id;
                vm.windowAddItem.lotteryType=params.row.lotteryType;
                vm.windowAddItem.yearIssue=params.row.yearIssue;
                vm.windowAddItem.issue=params.row.issue;
                vm.windowAddItem.jiuxiao=params.row.jiuxiao;
                vm.windowAddItem.shima=params.row.shima;
                vm.windowAddItem.openedSx=params.row.openedSx;
                vm.windowAddItem.openedNum=params.row.openedNum;
                vm.windowAdd.show = true
              }
            }
          }, this.$t('编辑')), h('Poptip', {
            props: {
              confirm: true,
              title: this.$t('您确定要删除?'),
              transfer: true
            },
            on: {
              'on-ok': () => {
                customPost('tuku/LiveJiuxiao', {op: 'del', id: params.row.id}).then(response => {
                  vm.$Message.success(response.data.msg)
                  vm.getList();
                })
                params.loading = false
              }
            }
          }, [
            h('Button', {
              style: {
                margin: '0 5px'
              },
              props: {
                type: this.$t('error'),
                placement: 'top',
                loading: params.isDeleting
              }
            }, this.$t('删除'))
          ])])
        }
      },],
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 50,
        listCount: 0
      },
      searchConf: {searchTime: [],}, // 搜索字段
      extraParams: [],
      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowAddItem: { //弹窗数据绑定
        id: 0
      },
      windowAddItemTemp: { //弹窗数据绑定
        id: 0
      },
      windowAddValidate: {//窗口校验规则
      },                            //----------------
    }
  },
  created() {
    let vm = this
    customPost('tuku/Pinglun', {op: 'getLotteryTypes'}).then(response => {
      vm.lotteryParams = response.data.data;
      vm.getList();
    })
  },
  mounted() {

  },
  methods: {
    changePage(page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize(size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search() {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList() {
      let vm = this
      vm.listLoading = true
      vm.searchConf.page= vm.tableShow.currentPage
      vm.searchConf.size= vm.tableShow.pageSize
      customPost('tuku/LiveJiuxiao', vm.searchConf).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    timeChange(datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({column, key, order}) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    preAdd() {
      let vm = this
      vm.windowAddItem.id=0;
      vm.windowAddItem.lotteryType=1;
      vm.windowAddItem.yearIssue='';
      vm.windowAddItem.issue='';
      vm.windowAddItem.jiuxiao='';
      vm.windowAddItem.shima='';
      vm.windowAddItem.openedSx='';
      vm.windowAddItem.openedNum=0;
      vm.windowAdd.show = true
    },
    windowAddCancel(data) {
      if (!data) {
        this.windowAddItem.id = 0
        this.windowAdd.show = false
        this.windowAdd.loading = false
        this.windowAdd.index = 0
        this.$refs['windowAddForm'].resetFields()
      }
    }, windowAddSubmit() {
      let vm = this
      vm.$refs['windowAddForm'].validate((valid) => {
        if (valid) {
          vm.windowAdd.loading = true
          Object.assign(vm.windowAddItemTemp, vm.windowAddItem) //浅复制数据params.row 给 vm.windowAddItemTemp
          vm.windowAddItemTemp.op='save';
          customPost('tuku/LiveJiuxiao',vm.windowAddItemTemp).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowAddCancel()
          }).catch(() => {
            vm.windowAdd.loading = false
          })
        }
      })
    },
  }
}
</script>
